<script lang="ts" setup>
import SancareOcticon from './SancareOcticon.vue'
import type { Class } from './types'

export interface ConditionElementProps {
  badgeClass: Class
  canEdit?: boolean
  canRemove: boolean
  isTextualValue: boolean
  label: string
  operator?: string | null
  textBeforeLabel?: string | null
  value: string
}

const props = withDefaults(defineProps<ConditionElementProps>(), {
  canEdit: false,
  operator: null,
  textBeforeLabel: null,
})

const emit = defineEmits<{
  (e: 'remove'): void
  (e: 'edit'): void
}>()

function handleEdit(): void {
  emit('edit')
}

function handleRemove(): void {
  emit('remove')
}
</script>

<template>
  <span class="internal-operator col-auto ms-2">
    {{ operator ?? '' }}
  </span>
  <div class="col-auto">
    <span
      class="badge text-wrap"
      :class="badgeClass"
    >
      <span v-if="textBeforeLabel">
        {{ textBeforeLabel }}
      </span>
      <span v-if="!isTextualValue">
        {{ label }} : {{ value }}
        <span
          v-if="canEdit"
          class="condition-edit mx-1"
          @click="handleEdit"
        >
          <sancare-octicon
            name="pencil"
            :width="14"
            :height="11"
          />
        </span>
        <span
          v-if="canRemove"
          class="condition-remove"
          @click="handleRemove"
        >
          <sancare-octicon
            name="x"
            :width="14"
            :height="11"
          />
        </span>
        <slot name="justifications" />
      </span>
      <span v-else>
        {{ label }} :
        <slot name="textual-value" />
      </span>
    </span>
  </div>
</template>

<style lang="scss">
@use 'sass:color';
@import '@sancare/typescript-commons/src/assets/styles/variables';

.internal-operator {
  padding: 0;
  min-width: 50px;
}

.editing {
  background-color: $sancare-dark-blue !important;
}

.condition-remove,
.condition-edit {
  cursor: pointer;
}
</style>
